import { z } from "zod";

const envSchema = z.object({
  // Prázdné = same-origin: SPA volá relativní `/api/...` a obsluhuje ji tentýž
  // API server, který ji servíruje. Díky tomu funguje produkce na JAKÉKOLI
  // doméně bez build-time hodnoty (VITE_API_URL se zapéká do bundlu, takže
  // absolutní URL na starou doménu = rozbité API po přesunu domény).
  // Absolutní http(s) URL je potřeba jen pro cross-origin dev (Vite :5173 ↔ API :4000).
  VITE_API_URL: z
    .string()
    .refine(
      (v) => v === "" || /^https?:\/\//.test(v),
      "VITE_API_URL musí být prázdné (same-origin) nebo absolutní http(s) URL",
    )
    .default(""),
  // Cloudflare Turnstile public site key for the bot/spam widget on public
  // forms. Optional — when empty the widget is not rendered and the server
  // skips verification (local dev / no-captcha deployments).
  VITE_TURNSTILE_SITE_KEY: z.string().optional(),
});

// Dev (vite dev na :5173) má API na jiném originu → fallback localhost:4000.
// Produkční build fallback "" = same-origin → nezávislé na doméně.
const apiUrlFallback = import.meta.env.DEV ? "http://localhost:4000" : "";

export const env = envSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL || apiUrlFallback,
  VITE_TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || undefined,
});
